<style lang="less">
    .libcontent-context {
        min-width: 166px;
    }
</style>
<i18n>
{
  "zh": {
    "reSelShape": "替换选中形状",
    "addSymbolFromLocal": "导入本地符号",
    "modSymbol": "编辑符号",
    "expSymbol": "导出符号",
    "del": "删除",
    "movUp": "上移",
    "movDown": "下移",
    "moveOut": "取消收藏",
    "deleteSymbol": "是否删除符号?",
    "addToCollect": "添加到我的符号库",
    "moveOutSymbol": "确定将该符号移出收藏?",
    "aidraw": "AI生成同款符号"
  },
  "en": {
    "reSelShape": "Replace the selected shape",
    "addSymbolFromLocal": "Import symbol.",
    "modSymbol": "Modify Symbol",
    "expSymbol": "Export Symbol",
    "del": "Delete",
    "movUp": "Move Up",
    "movDown": "Move Down",
    "moveOut": "Move Out",
    "deleteSymbol": "Confirmed to delete symbol?",
    "addToCollect": "Add to my library",
    "moveOutSymbol": "Remove symbol from collection?",
    "aidraw": "AI generates similar symbols"
  },
  "fr": {
    "reSelShape": "Remplacer une forme sélectionnée",
    "addSymbolFromLocal": "Importer un symbole",
    "modSymbol": "Modifier un symbole",
    "expSymbol": "Exporter un symbole",
    "del": "Supprimer",
    "movUp": "Déplacer vers le haut",
    "movDown": "Déplacer vers le bas",
    "moveOut": "Annuler la collecte",
    "deleteSymbol": "Supprimer le symbole?",
    "addToCollect": "Ajouter à collection",
    "moveOutSymbol": "Supprimer le symbole de la collection?",
    "aidraw": "IA génère des symboles similaires"
  },
  "de": {
    "reSelShape": "Ausgewählte Form ersetzen",
    "addSymbolFromLocal": "Symbol importieren",
    "modSymbol": "Symbol ändern",
    "expSymbol": "Symbol exportieren",
    "del": "Löschen",
    "movUp": "Nach oben",
    "movDown": "Nach unten",
    "moveOut": "Herausziehen",
    "deleteSymbol": "Bestätigung zum Löschen des Symbols?",
    "addToCollect": "Meiner Sammlung hinzufügen",
    "moveOutSymbol": "Symbol aus Sammlung entfernen?",
    "aidraw": "AI generiert ähnliche Symbole"
  },
  "jp": {
    "reSelShape": "選択した図形を置換",
    "addSymbolFromLocal": "ローカル図形をインポート",
    "modSymbol": "図形を編集",
    "expSymbol": "図形をエクスポート",
    "del": "削除",
    "movUp": "上へ移動",
    "movDown": "下へ移動",
    "moveOut": "お気に入りから削除",
    "deleteSymbol": "図形を削除しますか？",
    "addToCollect": "お気に入りに追加",
    "moveOutSymbol": "お気に入りから削除しますか？",
    "aidraw": "AIで同様の記号を生成"
  },
  "es": {
    "reSelShape": "Reemplazar forma seleccionada",
    "addSymbolFromLocal": "Importar símbolo",
    "modSymbol": "Modificar símbolo",
    "expSymbol": "Exportar símbolo",
    "del": "Eliminar",
    "movUp": "Mover arriba",
    "movDown": "Mover abajo",
    "moveOut": "Cancelar colección",
    "deleteSymbol": "¿Confirmar borrar el símbolo?",
    "addToCollect": "Añadir a mi colección",
    "moveOutSymbol": "¿Quitar el símbolo de la colección?",
    "aidraw": "La IA genera símbolos similares"
  },
  "pt": {
    "reSelShape": "Substituir a forma selecionada.",
    "addSymbolFromLocal": "Importar símbolo.",
    "modSymbol": "Modificar Símbolo",
    "expSymbol": "Exportar Símbolo",
    "del": "Eliminar",
    "movUp": "Mover para Cima",
    "movDown": "Mover para Baixo",
    "moveOut": "Mover para Fora",
    "deleteSymbol": "Confirmar para eliminar símbolo?",
    "addToCollect": "Adicionar à minha coleção",
    "moveOutSymbol": "Remover símbolo de coleção?",
    "aidraw": "A IA gera símbolos semelhantes"
  },
  "it": {
    "reSelShape": "Sostituisci la forma selezionata.",
    "addSymbolFromLocal": "Importa Simbolo",
    "modSymbol": "Modifica Simbolo",
    "expSymbol": "Esporta Simbolo",
    "del": "Elimina",
    "movUp": "Sposta Su",
    "movDown": "Sposta Giù",
    "moveOut": "Sposta Fuori",
    "deleteSymbol": "Confermi di voler eliminare il simbolo?",
    "addToCollect": "Aggiungi alla mia raccolta",
    "moveOutSymbol": "Rimuovere il simbolo dalla raccolta?",
    "aidraw": "AI genera simboli simili"
  },
  "tw": {
    "reSelShape": "替換選中形狀",
    "addSymbolFromLocal": "導入本地符號",
    "modSymbol": "編輯符號",
    "expSymbol": "導出符號",
    "del": "刪除",
    "movUp": "上移",
    "movDown": "下移",
    "moveOut": "取消收藏",
    "deleteSymbol": "是否刪除符號?",
    "addToCollect": "添加到我的符號庫",
    "moveOutSymbol": "確定將該符號移出收藏?"
  }
}
</i18n>
<template>
    <MenuList :menuList="menuList" :showTippy="false" @handleClicks="handleClicks(...arguments)" @handleMouseenter="handleMouseenter(...arguments)" />
</template>

<script lang="ts">
    declare var saveAs: any;
    declare var EDDocument: any;
    declare var EDVersion: any;
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import appConfig from "@/public/globalConfig";
    import { EDRAWMAX_USE_CUSTOMLIBRARY } from "@/env/";
    import MenuList from "@/app/components/MenuList.vue";
    import { InternalLimitTableIds, OverseaLimitTableIds, aidrawLibs } from "@/app/utils/constant";
    import { blobToBase64 } from "@/public/utils/tool.js";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class pageBarContext extends Vue {
        @Prop() readonly close!: any;
        @Inject()
        ["showMessage"];
        worker: any;
        userWorkerURL: string = appConfig.userWorkerURL;
        locker: boolean = false;
        offEventLocker: boolean = false;

        closeMenu() {
            // 关闭右键菜单
            // this.$store.commit("setStatus", {
            //     type: "showContextMenu",
            //     data: false,
            // });
            this.$store.commit("closeContext");
        }
        reflashLibrary() {
            // 通知library刷新列表
            let ts: any = this;
            let dbName = this.dbAndTable[0];
            if (this.isCustomLib) {
                dbName = this.$store.state.library.extraDB[2];
            }
            let tableID = this.dbAndTable[2];
            ts.$bus.$emit("setLibrary", {
                type: "updateLibrary",
                groupName: dbName,
                tableID: tableID,
            });
        }
        actionOver(message) {
            let ts: any = this;
            this.reflashLibrary();
            return ts.$bus.$asyncEmit("uploadToCloud", { message });
        }
        showDialog(target) {
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: target,
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
        }
        addSymbolFromLocal() {
            this.closeMenu();
            this.$track("library", "library content", "addSymbolFromLocal");
            this.showDialog("AddSymbolFromLocal");
        }
        editSymbol() {
            this.closeMenu();
            this.$track("library", "library content", "editSymbol");
            this.showDialog("EditSymbol");
        }
        outputSymbol() {
            // 保存ede
            let hasXmlDom: boolean = document.implementation.hasFeature("XML", "2.0");
            hasXmlDom = hasXmlDom && typeof XMLSerializer != "undefined";
            let xmlDoc: XMLDocument = EDDocument._genXmlDom(hasXmlDom, "Item");
            if (!xmlDoc) return null;
            let templateNode = xmlDoc.documentElement;
            templateNode.innerHTML = "<!--" + this.shape.shape + "-->";
            let contentEdt = '<?xml version="1.0" encoding="utf-8"?>' + templateNode.outerHTML;
            saveAs(new Blob([contentEdt], { type: "text/xml" }), this.shape.name + ".ede");

            // 保存图片
            saveAs(new Blob([this.shape.blob], { type: "image/png" }), this.shape.name + ".png");
            this.closeMenu();
        }
        replaceSymbol() {
            this.closeMenu();
            if (!this.vip && ~this.limitTableIds.indexOf(this.shape.tableID)) {
                this.$checkAuth({ type: "limitShapeType", buyTrigger: "library", libraryName: this.shape.name });
                return;
            }
            if (window["_view"]._activeShape) {
                window["_view"].replaceShape(this.shape.shape, this.shape.name, this.shape.langName, this.shape.tableID);
                this.$track("library", "library content", "replaceSymbol");
            }
        }
        deleteRemind() {
            if (this.contextLocker) return;
            this.offEventLocker = true; // 点击删除时增加保护，防止组件注销时移除bus监听
            this.closeMenu();

            let msg = this.isCollectLib ? this.$t("moveOutSymbol") : this.$t("deleteSymbol");
            this.showMessage({
                sponsor: "deleteSymbol",
                type: 0,
                content: msg,
            });
        }
        deleteSymbol() {
            if (this.contextLocker) return;
            this.contextLocker = true;

            if (this.mutiSelect) {
                this.$bus.$emit("deleteSymbol");
                this.closeMenu();
                return;
            }
            let dbName = this.dbAndTable[0];
            let tableName = this.dbAndTable[1];
            let { preItem, nowItem, nextItem, clickIndex } = this.libClickObj;
            let userInfo = this.$store.state.user.userInfo;

            this.worker = new Worker(this.userWorkerURL);
            this.worker.postMessage({
                type: "update",
                urls: this.urls,
                data: {
                    DBName: dbName,
                    tableName: tableName,
                    preItem,
                    nowItem,
                    updateType: "deleteSymbol",
                    tableID: this.dbAndTable[2],
                    versionDB: `myDBVersion_${userInfo.user_id}`,
                    clickIndex,
                },
            });
            this.worker.onmessage = (e) => {
                let message = e.data;
                if (message.type === "deleteOK") {
                    this.actionOver(message).then((e: any) => {
                        let version = e.data.version;
                        this.worker.postMessage({
                            type: "setVersion",
                            urls: this.urls,
                            data: {
                                versionDB: `myDBVersion_${userInfo.user_id}`,
                                tableID: this.dbAndTable[2],
                                version,
                                params: {
                                    updateModified: true,
                                },
                            },
                        });
                    });
                    this.$store.commit("setLibraryDisplayList", {
                        // 清空预览缓存
                        groupName: dbName,
                        tableName: tableName,
                        data: [],
                    });
                } else if (message.type === "setVersionOK") {
                    this.worker.terminate();
                }
                this.closeMenu();
            };
        }
        moveUpSymbol() {
            if (this.contextLocker) return;
            this.$track("library", "library content", "moveUpSymbol");
            this.contextLocker = true;
            this.closeMenu();
            let dbName = this.dbAndTable[0];
            let tableName = this.dbAndTable[1];
            let { preItem, nowItem, nextItem, clickIndex } = this.libClickObj;

            let userInfo = this.$store.state.user.userInfo;

            this.worker = new Worker(this.userWorkerURL);
            this.worker.postMessage({
                type: "update",
                urls: this.urls,
                data: {
                    DBName: dbName,
                    tableName: tableName,
                    preItem,
                    nowItem,
                    updateType: "moveUpSymbol",
                    tableID: this.dbAndTable[2],
                    versionDB: `myDBVersion_${userInfo.user_id}`,
                    clickIndex,
                },
            });
            this.worker.onmessage = (e) => {
                let message = e.data;
                if (message.type === "moveUpOK") {
                    this.actionOver(message).then((e: any) => {
                        let version = e.data.version;
                        this.worker.postMessage({
                            type: "setVersion",
                            urls: this.urls,
                            data: {
                                versionDB: `myDBVersion_${userInfo.user_id}`,
                                tableID: this.dbAndTable[2],
                                version,
                                params: {
                                    updateModified: true,
                                },
                            },
                        });
                    });
                } else if (message.type === "setVersionOK") {
                    this.worker.terminate();
                }
            };
        }
        moveDownSymbol() {
            if (this.contextLocker) return;
            this.$track("library", "library content", "moveDownSymbol");
            this.contextLocker = true;
            this.closeMenu();
            let dbName = this.dbAndTable[0];
            let tableName = this.dbAndTable[1];
            let { preItem, nowItem, nextItem, clickIndex } = this.libClickObj;

            let userInfo = this.$store.state.user.userInfo;

            this.worker = new Worker(this.userWorkerURL);
            this.worker.postMessage({
                type: "update",
                urls: this.urls,
                data: {
                    DBName: dbName,
                    tableName: tableName,
                    nextItem,
                    nowItem,
                    updateType: "moveDownSymbol",
                    tableID: this.dbAndTable[2],
                    versionDB: `myDBVersion_${userInfo.user_id}`,
                    clickIndex,
                },
            });
            this.worker.onmessage = (e) => {
                let message = e.data;
                if (message.type === "moveDownOK") {
                    this.actionOver(message).then((e: any) => {
                        let version = e.data.version;
                        this.worker.postMessage({
                            type: "setVersion",
                            urls: this.urls,
                            data: {
                                versionDB: `myDBVersion_${userInfo.user_id}`,
                                tableID: this.dbAndTable[2],
                                version,
                                params: {
                                    updateModified: true,
                                },
                            },
                        });
                    });
                } else if (message.type === "setVersionOK") {
                    this.worker.terminate();
                }
            };
        }
        showExpand() {
            this.$store.commit("setStatus", {
                type: "showContextExpand",
                data: true,
            });
        }
        showExp(e: MouseEvent, type: string) {
            let node = <HTMLElement>e.target;
            let ts: any = this;
            ts.$bus.$emit("changeContextType", type, node.offsetTop - (<HTMLElement>node.parentElement).scrollTop);

            // 避免非必要修改
            if (type === "addSymbolToLibs") {
                this.activeKey = "addToCollect";
                this.showExpand();
                ts.$bus.$emit("changeExpandPosition");
            } else {
                this.activeKey = "";
            }
        }
        // 我的收藏
        addToCollect() {
            this.closeMenu();
            this.$track("library", "library content", "addToCollect");
            let userInfo = this.$store.state.user.userInfo,
                collectDB = this.extraDB[2],
                collectTB = "collect",
                collectTBID = this.collectTBID;
            let addSymbolToCollect = () => {
                let dbName = collectDB;
                let tableName = collectTB;
                let tableID = collectTBID;
                let dbObj = {
                    name: this.shape.name,
                    [`${this.lang}_name`]: this.shape.langName,
                };
                dbObj["data"] = this.shape.shape;
                dbObj["parent"] = tableName;
                dbObj["blob"] = this.shape.blob;
                let updateData = {
                    DBName: collectDB,
                    tableName: collectTB,
                    tableID: collectTBID,
                    nowItem: -1,
                    updateType: "addSymbol",
                    dbObj: dbObj,
                    versionDB: `myDBVersion_${userInfo.user_id}`,
                };
                this.worker.postMessage({
                    type: "update",
                    data: updateData,
                });
                let ossList = this.$store.state.library.ossList;
                this.worker.onmessage = (e) => {
                    let message = e.data;
                    console.log(message);
                    if (message.type === "updateOK") {
                        this.actionOver(message).then((e: any) => {
                            let version = e.data.version;
                            this.worker.postMessage({
                                type: "setVersion",
                                data: {
                                    versionDB: `myDBVersion_${userInfo.user_id}`,
                                    tableID: this.dbAndTable[2],
                                    version,
                                    params: {
                                        updateModified: true,
                                    },
                                },
                            });
                        });
                    } else if (message.type === "setVersionOK") {
                        this.worker.terminate();
                    }
                };
            };
            this.worker = new Worker(this.userWorkerURL);
            this.worker.postMessage({
                type: "checkExist",
                urls: this.urls,
                data: {
                    DBName: collectDB,
                    tableName: collectTB,
                    versionDB: `myDBVersion_${userInfo.user_id}`,
                },
            });
            this.worker.onmessage = (e) => {
                let message = e.data,
                    type = message.type;
                if (type == "existed") {
                    addSymbolToCollect();
                } else if (type == "newOK") {
                    addSymbolToCollect();
                }
            };
        }

        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            let clickEvents = new Map([
                [
                    "reSelShape",
                    () => {
                        event.stopPropagation();
                        this.replaceSymbol();
                    },
                ],
                [
                    "modSymbol",
                    () => {
                        event.stopPropagation();
                        this.editSymbol();
                    },
                ],
                [
                    "movUp",
                    () => {
                        event.stopPropagation();
                        this.canMoveUp && this.moveUpSymbol();
                    },
                ],
                [
                    "movDown",
                    () => {
                        event.stopPropagation();
                        this.canMoveDown && this.moveDownSymbol();
                    },
                ],
                [
                    "moveOut",
                    () => {
                        event.stopPropagation();
                        this.deleteSymbol();
                    },
                ],
                [
                    "del",
                    () => {
                        event.stopPropagation();
                        this.isCustomLib && this.deleteSymbol();
                    },
                ],
                [
                    "aidraw",
                    () => {
                        event.stopPropagation();
                        this.toAidraw();
                    },
                ],
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }

        handleMouseenter(...args) {
            let key = args[0],
                event = args[1];
            this.showExp(event, key);
        }

        // ai3 协议
        get userInfo() {
            return this.$store.state.userInfo || this.$store.state.user.userInfo;
        }
        agree = false;
        get agreePlus() {
            return this.agree || this.noLoginEditor;
        }
        readLocal() {
            let str = localStorage.getItem("ai3") || null;
            if (str) {
                let ai3Obj = JSON.parse(str);
                let list = ai3Obj.agreement || [];
                let exit = false;
                for (let i = 0; i < list.length; i++) {
                    if (this.userInfo.user_id == list[i].user_id) {
                        exit = true;
                        this.agree = list[i].data;
                        break;
                    }
                }
                !exit && (this.agree = false);
            } else {
                this.agree = false;
            }
            return this.agree;
        }
        showAgreement() {
            this.$store.commit("setDialogState", {
                type: "aiDrawBtn",
                data: "",
            });
            this.$bus.$emit("showAIPanel", true);
            this.$nextTick(() => {
                this.$bus.$emit("showAgreement", true);
            });
        }
        get noLoginEditor() {
            return this.$store.state.user.noLoginEditor;
        }

        toAidraw() {
            this.closeMenu();
            if (this.agreePlus || this.readLocal()) {
            } else {
                this.showAgreement();
                this.$store.commit("setDialogState", {
                    type: "aiDrawBtn",
                    data: "libContentContextToAidraw",
                });
                return;
            }
            let list = this.$store.state.library.publicLibraryData;
            let lib = list.find((item) => item.id == this.dbAndTable[2]);
            let shape = lib.data.find((item) => item.table_index == this.libClickObj.clickIndex);
            if (lib && shape && shape.blob) {
                const str = `${lib[this.lang] || lib["en"]}, ${shape[this.lang + "_name"] || shape["en_name"]}`;
                blobToBase64(shape.blob).then((base64) => {
                    this.$store.commit("setDialogState", {
                        type: "dialogType",
                        data: "AIDraw",
                    });
                    this.$store.commit("setDialogState", {
                        type: "showDialog",
                        data: true,
                    });
                    this.$nextTick(() => {
                        this.$bus.$emit("setAidrawOption", {
                            menu: 1,
                            style: 0,
                            image: base64,
                            text: str,
                        });
                    });
                    this.sensors.track("openAiDrawingWindow", {
                        Catalogues: "AiDrawing",
                        open_way: "generateSimilarSymbols",
                        similar_library_name: lib["en"],
                        similar_symbol_name: shape["en_name"],
                        search_symbol_content: "unknown",
                    });
                });
            }
        }

        get mutiSelect() {
            return this.$store.state.library.mutiSelect;
        }
        get extraDB() {
            return this.$store.state.library.extraDB;
        }
        get libPage() {
            return this.$store.state.library.libPage;
        }
        get isSearchLib() {
            return this.$store.state.library.libPage === "searchLib";
        }
        get collectTBID() {
            return this.$store.state.library.collectTBID;
        }
        get isCollectLib() {
            return this.dbAndTable[2] == this.collectTBID;
        }
        get isCustomLib() {
            return this.dbAndTable[2] >= this.collectTBID;
        }
        get currentOpePageIndex() {
            return this.$store.state.ui.currentOpePageIndex;
        }
        get dbAndTable() {
            return this.$store.state.ui.selectLibrary;
        }
        get libClickObj() {
            return this.$store.state.ui.libClickObj;
        }
        get shape() {
            return this.$store.state.ui.selectLibraryShape;
        }
        get canMoveUp() {
            return this.$store.state.ui.canMoveUpSymbol;
        }
        get canMoveDown() {
            return this.$store.state.ui.canMoveDownSymbol;
        }
        get contextLocker() {
            return this.$store.state.library.contextLocker;
        }
        set contextLocker(v) {
            this.$store.commit("setLibraryState", {
                type: "contextLocker",
                data: v,
            });
        }
        get isSelect() {
            return this.$store.state.shape.isActived;
        }
        get specialShape() {
            // 特殊形状屏蔽替换形状功能
            return (
                this.$store.getters.isTableUnit ||
                this.$store.getters.isConnectLine ||
                this.$store.state.shape.isMMShape ||
                this.$store.getters.isImage
            );
        }
        get useCustomLib() {
            return EDRAWMAX_USE_CUSTOMLIBRARY && window.EDCONFIG.MY_LIBRARY_ENABLE;
        }
        get limitTableIds() {
            return this.internal ? InternalLimitTableIds : OverseaLimitTableIds;
        }
        get menuList() {
            let list = [
                {
                    key: "reSelShape",
                    disabled: !this.isSelect || this.specialShape || this.mutiSelect,
                    showVip: !this.vip && ~this.limitTableIds.indexOf(this.shape.tableID),
                },
                { key: "modSymbol", disabled: this.mutiSelect },
                { divide: true },
                { key: "movUp", isRender: !this.isSearchLib, disabled: !this.canMoveUp || this.mutiSelect },
                { key: "movDown", isRender: !this.isSearchLib, disabled: !this.canMoveDown || this.mutiSelect },
                { key: "moveOut", isRender: this.isCollectLib },
                { key: "del", isRender: this.isCustomLib && this.collectTBID != this.dbAndTable[2] },
                {
                    key: "addToCollect",
                    isRender: !this.isCustomLib && this.useCustomLib,
                    expand: true,
                    active: false,
                    showVip: !this.vip && ~this.limitTableIds.indexOf(this.shape.tableID),
                },
                { divide: aidrawLibs.includes(this.dbAndTable[2]) },
                { key: "aidraw", isRender: aidrawLibs.includes(this.dbAndTable[2]) },
            ];
            list.forEach((v) => {
                if ("active" in v) {
                    v.active = this.activeKey === v.key;
                }
            });
            let resultList = [];
            list.filter((i) => (i.hasOwnProperty("isRender") ? i.isRender : i.hasOwnProperty("divide") ? i.divide : true)).map((item) => {
                resultList.push(item.divide ? item : Object.assign({}, item, { label: this.$t(item.key) }));
            });
            return { container: "libcontent-context", list: resultList };
        }

        activeKey = "";

        mounted() {}

        created() {
            let ts: any = this;
            ts.$bus.$on("msgOperation", (data) => {
                if (data.sponsor == "deleteSymbol") {
                    if (data.data) {
                        ts.$bus.$off("msgOperation");
                        this.deleteSymbol();
                    } else ts.$bus.$off("msgOperation");
                }
            });

            // ts.$bus.$on("libContentContextToAidraw", () => {
            //     this.toAidraw();
            // });
        }
        beforeDestroy() {
            if (!this.offEventLocker) {
                let ts: any = this;
                ts.$bus.$off("msgOperation");
            }
            this.activeKey = "";
            // let ts: any = this;
            // ts.$bus.$off("libContentContextToAidraw");
        }
    }
</script>
